export function getValue(_ref) {
  var activeIndex = _ref.activeIndex,
    percentage = _ref.percentage,
    value = _ref.value;
  if (typeof activeIndex !== 'undefined' && activeIndex >= 0) {
    return activeIndex;
  }
  if (percentage) {
    if (value < 0 || value > 1) {
      return 0;
    }
    return value;
  }
  if (value < 0) {
    return 0;
  }
  return value - 1;
}